/**
 * The tidy-up's notes to the cook, found where they don't belong: in the recipe itself (2026-10-17).
 * Live, a tidy-up wrote what it couldn't confirm into the recipe and the family's cookbook printed
 * it: "(Confirm oil temperature/heat level and browning time — not specified in source.)" after a
 * step, and Kitchen notes about what "could not be confirmed from the source". The tidy-up now asks
 * in its `questions` instead; a note it still writes is pointed out while the family checks the
 * recipe, for them to answer or take out. Nothing is ever removed for them: taking words out by
 * pattern deleted a family's own steps in review ("Verify the oven is at 325°F…").
 *
 * A note is told by the tidy-up's own way of speaking about its source or to the cook ("not
 * specified", "did not specify", "not given in the original", "please confirm", "could not be
 * confirmed", "before relying on"). A family can say these too; then they are only asked to look.
 *
 * Shared by the tidy-up (services) and the family's recipe page (web).
 */
const REMARK = new RegExp([
    String.raw `\bnot\s+specified\b`,
    String.raw `\b(?:did|does|do)(?:\s+not|n['’]t)\s+specify\b`,
    String.raw `\bnot\s+(?:given|stated|restated|contained|provided|indicated)\s+(?:in|on|by)\s+(?:the\s+)?(?:source|original)\b`,
    String.raw `\bplease\s+(?:confirm|verify)\b`,
    String.raw `\b(?:could|can)(?:\s*not|n['’]t)\s+be\s+(?:confirmed|verified)\b`,
    String.raw `\bshould\s+be\s+(?:confirmed|verified)\b`,
    String.raw `\bbefore\s+relying\s+on\b`,
].join("|"), "iu");
/** The longest stretch of a note quoted back to the family. */
const QUOTE_LIMIT = 160;
/** A note as the family is shown it: its own words, cut short at a word if it runs long. */
function quoted(text) {
    const words = text.replace(/\s+/gu, " ").trim();
    if (words.length <= QUOTE_LIMIT)
        return words;
    const cut = words.slice(0, QUOTE_LIMIT - 1);
    return `${cut.slice(0, Math.max(cut.lastIndexOf(" "), QUOTE_LIMIT / 2)).trimEnd()}…`;
}
/**
 * Each sentence of `text` that reads like the tidy-up's note to the cook, quoted, in order; none
 * when it reads like the family's own words.
 */
export function recipeRemarks(text) {
    if (!text || !REMARK.test(text))
        return [];
    const sentences = text.split(/(?<=[.!?…]["”’)\]]*)\s+|\n+/u).filter((part) => part.trim());
    return [...new Set(sentences.filter((sentence) => REMARK.test(sentence)).map(quoted))];
}
//# sourceMappingURL=recipe-remarks.js.map